import NavigateBeforeOutlinedIcon from "@mui/icons-material/NavigateBeforeOutlined";
import type { SvgIconProps } from "@mui/material/SvgIcon";

const PreviousIcon = (props: SvgIconProps) => (
  <NavigateBeforeOutlinedIcon {...props} fontSize="small" />
);

export default PreviousIcon;
